<div class="container">
    <div class="container-body">
        <div class="example-card">

            <mat-card>
                <mat-card-header>
                    <div mat-card-avatar></div>
                    <mat-card-title>{{candidates[0].name | titlecase}} {{candidates[0].lastname |titlecase}}
                    </mat-card-title>
                    <mat-card-subtitle>Candidato</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <p><span>CURP: </span>{{candidates[0].username}}</p>
                    <p><span>Licencia: </span>{{candidates[0].license}}</p>
                    <p><span>Reclutador: </span>{{candidates[0].recruiter_name | titlecase}} {{candidates[0].recruiter_lastname | titlecase}}</p>
                </mat-card-content>
                <mat-card-actions>
                    <!--  <button mat-button>LIKE</button>
                    <button mat-button>SHARE</button> -->
                </mat-card-actions>
            </mat-card>

        </div>
        <div class="example-card">

            <mat-card class="matcard">
                <!-- <mat-card-header>
                    <div mat-card-avatar class="example-header-image"></div>
                    <mat-card-title>Shiba Inu</mat-card-title>
                    <mat-card-subtitle>Dog Breed</mat-card-subtitle>
                </mat-card-header>-->
                <!-- insert image -->

                <div>
                    <img [src]="images+candidates[0].profile_picture" height="100" width="100" alt="">

                </div>

                <div>
                    <mat-card-content>
                        <div [ngClass]="{
                            'light1': averageweighed>=9 && averageweighed<=10,
                            'light2': averageweighed<9 && averageweighed>=8,
                            'light3': averageweighed<8 && averageweighed>=7,
                            'light4': averageweighed<7
                        }">
                            {{indicator}}
                        </div>
                    </mat-card-content>
                </div>

                <mat-card-actions>
                    <!--  <button mat-button>LIKE</button>
                    <button mat-button>SHARE</button> -->
                </mat-card-actions>
            </mat-card>

        </div>
    </div>
    <div class="evaluations">
        <div>

            <mat-card>
                <mat-card-header>
                    <div mat-card-avatar></div>
                    <mat-card-title>Resumen de evaluaciones
                    </mat-card-title>
                    <mat-card-subtitle></mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>


                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                        <!--- Note that these columns can be defined in any order.
                              The actual rendered columns are set as a property on the row definition" -->

                        <!-- Position Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef> Examen </th>
                            <td mat-cell *matCellDef="let element"> <a href="javascript:void(0)" (click)="newMessage(element)">{{element.name}} </a></td>
                            <td mat-footer-cell *matFooterCellDef><span> Promedio General</span> </td>

                        </ng-container>

                        <!-- Position Column -->
                        <ng-container matColumnDef="weighing">
                            <th mat-header-cell *matHeaderCellDef> Ponderación </th>
                            <td mat-cell *matCellDef="let element"> {{element.weighing}} % </td>
                            <td mat-footer-cell *matFooterCellDef> <span>Promedio Ponderado</span></td>

                        </ng-container>

                        <ng-container matColumnDef="weighedscore">
                            <th mat-header-cell *matHeaderCellDef> Calificación Ponderada </th>
                            <td mat-cell *matCellDef="let element"> {{element.score*element.weighing/totalweigh*10 |
                                number:'1.1-2'}} </td>
                            <td mat-footer-cell *matFooterCellDef> <span>{{averageweighed | number:'1.1-2'}} </span>
                            </td>

                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="score">
                            <th mat-header-cell *matHeaderCellDef> Calificación </th>
                            <td mat-cell *matCellDef="let element"> {{element.score*10 | number:'1.1-2'}} </td>
                            <td mat-footer-cell *matFooterCellDef> <span>{{average | number:'1.1-2'}}</span></td>


                        </ng-container>

                        <!-- Weight Column -->
                        <ng-container matColumnDef="datestamp">
                            <th mat-header-cell *matHeaderCellDef> Fecha </th>
                            <td mat-cell *matCellDef="let element"> {{element.datestamp*1000 | date:'short' }} </td>
                            <td mat-footer-cell *matFooterCellDef></td>

                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
                    </table>


                </mat-card-content>
                <mat-card-actions>
                </mat-card-actions>
            </mat-card>

        </div>
    </div>

    <div class="evaluations missing">
        <div>

            <mat-card>
                <mat-card-header>
                    <div mat-card-avatar></div>
                    <mat-card-title>Evaluaciones Faltantes
                    </mat-card-title>
                    <mat-card-subtitle></mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>

                    <mat-list>
                        <div *ngFor="let miss of missing">
                            <mat-list-item> {{miss.name}} </mat-list-item>

                        </div>
                    </mat-list>


                </mat-card-content>
                <mat-card-actions>
                </mat-card-actions>
            </mat-card>

        </div>

    </div>
</div>